// ═══════════════════════════════════════════════════════════════════════════
// PREMIUM AI TASKS - Rozbudowane tryby pracy z Mentorem AI
// Każde zadanie = kontekstowy tryb praktyki z inteligentnym AI
// Wszystko w aplikacji. Zero zewnętrznych narzędzi.
// ═══════════════════════════════════════════════════════════════════════════

export const dayTasks = {
  1: {
    dayTitle: "Twój pierwszy skuteczny prompt",
    dayContext: "Podstawy promptów - struktura KKF (Kontekst, Konkret, Format)",
    tasks: [
      {
        id: "d1_t1",
        title: "Warsztat: Budowanie promptu od zera",
        description: "Razem z AI zbudujesz profesjonalny prompt krok po kroku",
        goal: "Stworzyć działający, profesjonalny prompt metodą RZKF",
        aiMode: "guided_build",
        aiStartMessage: `**Warsztat: Budowanie promptu**

Zbudujemy razem profesjonalny prompt od zera. Prowadzę Cię przez każdy element - Ty decydujesz o treści, ja pomagam z jakością.

**Struktura RZKF:**
- **R**ola – kim jest AI
- **T**ask – co ma zrobić
- **K**ontekst – dla kogo, w jakiej sytuacji
- **F**ormat – jak ma wyglądać odpowiedź

---

Zacznijmy. **Podaj mi temat**, w którym chcesz stworzyć prompt.

Może to być cokolwiek z Twojego życia lub pracy - email, post, analiza, plan, oferta. Im bardziej z życia wzięte, tym lepiej się nauczysz.`
      },
      {
        id: "d1_t2",
        title: "Laboratorium: Słaby vs Dobry vs Premium",
        description: "AI pokaże Ci ten sam temat w trzech wersjach jakości",
        goal: "Zrozumieć co odróżnia przeciętny prompt od profesjonalnego",
        aiMode: "live_comparison",
        aiStartMessage: `**Laboratorium promptów**

Przeprowadzę eksperyment. Wezmę Twój temat i pokażę go w trzech wersjach:

- **Wersja SŁABA** – typowy, leniwy prompt
- **Wersja DOBRA** – poprawna, ale standardowa
- **Wersja PREMIUM** – profesjonalny, zoptymalizowany prompt

Zobaczysz dokładnie co sprawia, że każda kolejna wersja daje drastycznie lepsze wyniki.

---

**Podaj temat** – o czym chcesz, żeby był prompt?

Przykłady: oferta handlowa, plan treningowy, post na LinkedIn, analiza rynku, email do szefa.`
      },
      {
        id: "d1_t3",
        title: "Diagnostyka: Znajdź i napraw błędy",
        description: "Dostajesz wadliwy prompt - Twoim zadaniem jest go naprawić z pomocą AI",
        goal: "Nauczyć się identyfikować i eliminować typowe błędy w promptach",
        aiMode: "diagnosis",
        aiStartMessage: `**Diagnostyka promptów**

Podam Ci prompt z ukrytymi problemami. Twoim zadaniem jest je znaleźć.

---

**Prompt do analizy:**

*"Hej, napisz mi coś fajnego o biznesie. Ma być dobre i pomocne, ale nie za długie. Dzięki!"*

---

Przeanalizuj ten prompt. Co widzisz?

- Jakich elementów brakuje?
- Co jest zbyt ogólne?
- Jak AI zinterpretuje "coś fajnego"?
- Co by się stało, gdybyś wysłał to do ChatGPT?

Napisz swoją analizę – potem pokażę Ci profesjonalną naprawę.`
      }
    ]
  },
  
  2: {
    dayTitle: "Role i persony AI",
    dayContext: "Nadawanie ról AI zmienia perspektywę i jakość odpowiedzi",
    tasks: [
      {
        id: "d2_t1",
        title: "Kreator: Zaprojektuj osobistego eksperta AI",
        description: "Stworzysz pełną personę AI dopasowaną do Twoich potrzeb",
        goal: "Stworzyć gotową personę AI do wielokrotnego użytku",
        aiMode: "persona_creator",
        aiStartMessage: `**Kreator Persony AI**

Stworzymy Twojego osobistego eksperta AI - personę, którą będziesz mógł używać wielokrotnie w różnych sytuacjach.

Dobrze zaprojektowana persona zmienia jakość odpowiedzi AI o 200-300%.

---

Zaczynam od fundamentalnego pytania:

**W jakiej dziedzinie potrzebujesz eksperta?**

Pomyśl o swojej pracy, hobby lub wyzwaniu, z którym się mierzysz. Im bardziej konkretne, tym lepsza persona.`
      },
      {
        id: "d2_t2",
        title: "Eksperyment: Jedno pytanie, trzy perspektywy",
        description: "Zobaczysz jak ta sama kwestia wygląda z perspektywy trzech różnych ekspertów",
        goal: "Zrozumieć potęgę ról i perspektyw w AI",
        aiMode: "multi_expert",
        aiStartMessage: `**Analiza wieloperspektywiczna**

Zadam Twoje pytanie trzem różnym ekspertom AI. Każdy ma inny background, inne priorytety i inny sposób myślenia.

**Eksperci:**
1. **Analityk** – dane, metryki, fakty
2. **Strateg** – wizja, plan, długi termin
3. **Praktyk** – konkretne działania, szybkie wyniki

---

**Zadaj pytanie** – zawodowe, biznesowe lub osobiste. Cokolwiek, gdzie różne perspektywy mogą dać wartość.

Im trudniejsze pytanie, tym ciekawsze będą różnice w odpowiedziach.`
      },
      {
        id: "d2_t3",
        title: "Warsztat: AI dopasowane do Twojej pracy",
        description: "Stworzysz prompt-asystenta idealnie dopasowanego do Twojej codziennej pracy",
        goal: "Mieć gotową personę do codziennego użytku w pracy",
        aiMode: "work_assistant",
        aiStartMessage: `**Asystent zawodowy AI**

Stwórzmy AI dopasowane do Twojej codziennej pracy. Będzie znało Twój kontekst, Twoje wyzwania i Twój styl.

---

Potrzebuję od Ciebie trzech rzeczy:

1. **Czym się zajmujesz?** (branża, stanowisko, główne zadania)
2. **Z czym najczęściej potrzebujesz pomocy?** (pisanie, analiza, planowanie, decyzje?)
3. **Jaki styl wolisz?** (krótkie i na temat vs rozbudowane analizy)

Opisz swoją sytuację - im więcej kontekstu, tym lepszego asystenta stworzę.`
      }
    ]
  },
  
  3: {
    dayTitle: "Łańcuchy promptów",
    dayContext: "Dzielenie złożonych zadań na serię kroków",
    tasks: [
      {
        id: "d3_t1",
        title: "Architekt: Rozłóż zadanie na łańcuch promptów",
        description: "Nauczysz się rozbijać złożone projekty na serię efektywnych kroków",
        goal: "Opanować technikę łańcuchowania promptów",
        aiMode: "chain_architect",
        aiStartMessage: `**Architekt łańcuchów**

Jeden prompt na złożone zadanie = słabe wyniki.
Seria połączonych promptów = profesjonalne rezultaty.

Nauczysz się rozbijać wielkie zadania na serię małych, precyzyjnych kroków - każdy budujący na poprzednim.

---

**Podaj złożone zadanie**, które chcesz wykonać.

Najlepiej coś z Twojej pracy:
- przygotowanie prezentacji
- napisanie artykułu
- zaplanowanie kampanii
- analiza problemu biznesowego
- stworzenie oferty

Im bardziej realne zadanie, tym więcej wyniesiesz z ćwiczenia.`
      },
      {
        id: "d3_t2",
        title: "Iteracja: Od wersji 1.0 do wersji premium",
        description: "Zaczniesz od podstawowego draftu i wspólnie z AI rozwiniesz go przez 3 rundy",
        goal: "Opanować iteracyjne doskonalenie promptów i wyników",
        aiMode: "iteration",
        aiStartMessage: `**Iteracja: 3 rundy doskonalenia**

Profesjonaliści nigdy nie kończą na pierwszej wersji. Przećwiczymy proces, który odróżnia amatorów od ekspertów.

**Plan:**
- **Runda 1:** Pierwszy draft - celowo może być prosty
- **Runda 2:** Analiza + konkretne poprawki
- **Runda 3:** Wersja profesjonalna

---

**Napisz swój pierwszy prompt** - na dowolny temat.

Może być niedoskonały. Może być prosty. To część procesu. Zaczynamy od tego co masz, a ja pokażę jak to systematycznie ulepszać.`
      },
      {
        id: "d3_t3",
        title: "Projekt: Wykonaj zadanie od A do Z",
        description: "Zrealizujesz mini-projekt od pomysłu do gotowego rezultatu",
        goal: "Praktyczne zastosowanie łańcuchowania w realnym projekcie",
        aiMode: "mini_project",
        aiStartMessage: `**Mini-projekt: Od zera do rezultatu**

Wykonamy razem konkretny projekt w 4 krokach. Na koniec będziesz mieć gotowy rezultat.

**Wybierz projekt:**

1. **Post ekspercki na LinkedIn** – budujący autorytet w Twojej dziedzinie
2. **Cold email** – pierwszy kontakt, który ktoś przeczyta do końca
3. **Plan rozwiązania problemu** – od diagnozy do action items
4. **Pitch w 60 sekund** – przekonujące przedstawienie pomysłu

Wybierz numer (1-4) albo opisz własny mini-projekt.`
      }
    ]
  },
  
  4: {
    dayTitle: "Zaawansowane techniki",
    dayContext: "Few-shot learning, Chain-of-Thought, meta-prompting",
    tasks: [
      {
        id: "d4_t1",
        title: "Few-shot: Naucz AI przez przykłady",
        description: "Opanujesz technikę, którą używają profesjonaliści do precyzyjnej kontroli AI",
        goal: "Opanować few-shot learning w praktyce",
        aiMode: "few_shot",
        aiStartMessage: `**Few-shot Learning**

Few-shot to technika, gdzie zamiast opisywać czego chcesz, **pokazujesz to na przykładach**. AI rozpoznaje wzorzec i go replikuje.

To jedna z najpotężniejszych technik - stosowana w profesjonalnych systemach AI.

---

**Wybierz ćwiczenie:**

1. **Style pisania** – nauczymy AI Twojego stylu komunikacji
2. **Formaty odpowiedzi** – nauczymy AI dokładnego formatu, którego potrzebujesz
3. **Ton i rejestr** – nauczymy AI precyzyjnego tonu

Wybierz numer (1-3) albo opisz, do czego chcesz zastosować few-shot.`
      },
      {
        id: "d4_t2",
        title: "Chain-of-Thought: Wymuś głębokie myślenie",
        description: "Nauczysz AI pokazywać pełny tok rozumowania zamiast powierzchownych odpowiedzi",
        goal: "Uzyskiwać głębsze, lepiej uzasadnione odpowiedzi od AI",
        aiMode: "chain_of_thought",
        aiStartMessage: `**Chain-of-Thought**

Większość ludzi dostaje od AI powierzchowne odpowiedzi, bo nie wie jak wymusić głęboką analizę.

Chain-of-Thought sprawia, że AI pokazuje **cały tok rozumowania** - krok po kroku, z argumentami i kontrargumentami.

---

**Zadaj mi pytanie wymagające analizy:**

Najlepiej sprawdza się na:
- decyzjach biznesowych
- dylematach strategicznych
- porównywaniu opcji
- diagnozowaniu problemów

Twoje pytanie - im trudniejsze, tym lepiej zobaczysz różnicę.`
      },
      {
        id: "d4_t3",
        title: "Meta-prompting: AI tworzy prompty za Ciebie",
        description: "AI zaprojektuje zoptymalizowany prompt na podstawie Twojego celu",
        goal: "Używać AI do projektowania i optymalizacji promptów",
        aiMode: "meta_prompt",
        aiStartMessage: `**Meta-prompting**

Meta-prompting to technika na poziomie zaawansowanym: **AI tworzy prompty za Ciebie**.

Ty mówisz CO chcesz osiągnąć. AI mówi JAK najlepiej o to zapytać.

---

**Opisz swój cel** - co chcesz uzyskać od AI?

Przykłady:
- "Potrzebuję pomocy w pisaniu ofert handlowych"
- "Chcę generować pomysły na content"
- "Potrzebuję analizy danych sprzedażowych"

Im bardziej szczegółowy cel, tym lepszy prompt wygeneruję.`
      }
    ]
  },
  
  5: {
    dayTitle: "Automatyzacja z AI",
    dayContext: "Szablony, workflow, systemy promptów",
    tasks: [
      {
        id: "d5_t1",
        title: "Generator: Stwórz reużywalny szablon",
        description: "Zbudujesz szablon promptu, który będziesz mógł używać wielokrotnie",
        goal: "Mieć gotowy, profesjonalny szablon do wielokrotnego użycia",
        aiMode: "template_generator",
        aiStartMessage: `**Generator szablonów**

Szablon promptu to jak formularz - raz tworzysz, potem uzupełniasz zmienne i masz profesjonalny prompt w 10 sekund.

**Struktura:**
\`[STAŁA CZĘŚĆ] + [ZMIENNA: ___] + [STAŁA CZĘŚĆ]\`

---

**Jakie zadanie powtarzasz regularnie?**

Pomyśl o czymś, co robisz co tydzień lub częściej:
- odpowiedzi na zapytania klientów
- posty w mediach społecznościowych
- notatki ze spotkań
- maile follow-up
- raporty

Opisz swoje powtarzalne zadanie.`
      },
      {
        id: "d5_t2",
        title: "Konstruktor: Zaprojektuj workflow AI",
        description: "Stworzysz system połączonych promptów, gdzie output jednego staje się inputem następnego",
        goal: "Stworzyć działający, wielokrokowy workflow AI",
        aiMode: "workflow_builder",
        aiStartMessage: `**Konstruktor workflow**

Workflow to seria połączonych promptów: output jednego staje się inputem następnego.

**Przykład workflow "Content":**
1. Generowanie pomysłów na temat →
2. Tworzenie struktury artykułu →
3. Pisanie poszczególnych sekcji →
4. Edycja i optymalizacja

Każdy krok to osobny, precyzyjny prompt.

---

**Jaki proces chcesz zautomatyzować?**

Opisz coś z Twojej codziennej pracy - od inputu do finalnego outputu.`
      },
      {
        id: "d5_t3",
        title: "System: Osobisty ekosystem AI",
        description: "Zaprojektujesz kompletny system AI wspierający Twoją codzienną produktywność",
        goal: "Mieć zaprojektowany osobisty system AI",
        aiMode: "personal_system",
        aiStartMessage: `**Osobisty system AI**

Stworzymy Twój ekosystem AI - zestaw narzędzi, szablonów i workflow dopasowanych do Twojego życia i pracy.

---

**Opowiedz mi o swoim typowym dniu:**

1. Jakie zadania zajmują Ci najwięcej czasu?
2. Co robisz powtarzalnie i mechanicznie?
3. Gdzie AI mogłoby zaoszczędzić Ci godzinę dziennie?

Im więcej kontekstu podasz, tym lepszy system zaprojektuję.`
      }
    ]
  },
  
  6: {
    dayTitle: "AI dla kreatywności",
    dayContext: "Brainstorming, ideacja, twórcze pisanie",
    tasks: [
      {
        id: "d6_t1",
        title: "Ideacja: Burza mózgów z AI",
        description: "Wygeneruj świeże pomysły z AI jako partnerem kreatywnym",
        goal: "Wygenerować niestandardowe pomysły i wybrać najlepsze",
        aiMode: "ideation",
        aiStartMessage: `**Sesja ideacji**

Będę Twoim partnerem kreatywnym. Zasady:
- Żadnych złych pomysłów na starcie
- Ilość przed jakością
- Łączymy niespodziewane elementy
- Dopiero potem filtrujemy

---

**Na jaki temat generujemy pomysły?**

Może to być:
- nowy projekt lub produkt
- rozwiązanie problemu
- content do stworzenia
- strategia marketingowa
- cokolwiek, co wymaga kreatywności

Twój temat do brainstormu?`
      },
      {
        id: "d6_t2",
        title: "Multianaliza: Problem z 5 perspektyw",
        description: "AI przeanalizuje Twój problem z perspektywy 5 różnych ekspertów",
        goal: "Zobaczyć swój problem z perspektyw, na które sam byś nie wpadł",
        aiMode: "multi_analysis",
        aiStartMessage: `**Multianaliza: 5 perspektyw**

Przeanalizuję Twój problem oczami 5 różnych ekspertów:

1. **Strateg** – co jest naprawdę ważne?
2. **Sceptyk** – co może pójść nie tak?
3. **Optymista** – jakie są ukryte szanse?
4. **Użytkownik** – czego ludzie naprawdę potrzebują?
5. **Innowator** – co by zrobił ktoś odważny?

---

**Opisz swój problem lub wyzwanie.**

Im bardziej konkretnie opiszesz sytuację, tym trafniejsze będą perspektywy.`
      },
      {
        id: "d6_t3",
        title: "Współtworzenie: Pisz razem z AI",
        description: "Stwórzcie coś razem - zdanie po zdaniu, pomysł po pomyśle",
        goal: "Doświadczyć kreatywnej synergii z AI",
        aiMode: "co_creation",
        aiStartMessage: `**Współtworzenie**

Napiszemy coś razem. Ja zaczynam lub kontynuuję, Ty kierunkujesz i rozwijasz.

**Co tworzymy?**

1. **Post na LinkedIn** – angażujący, profesjonalny
2. **Cold email** – krótki, konkretny, skuteczny
3. **Opis produktu/usługi** – przekonujący
4. **Pitch pomysłu** – 60-sekundowe intro
5. **Artykuł ekspercki** – budujący autorytet

Wybierz numer (1-5) albo zaproponuj coś swojego.`
      }
    ]
  },
  
  7: {
    dayTitle: "Research i analiza",
    dayContext: "Zbieranie informacji, synteza, wnioski",
    tasks: [
      {
        id: "d7_t1",
        title: "Research: Strukturalny research z AI",
        description: "Przeprowadź profesjonalny research od pytań badawczych do wniosków",
        goal: "Nauczyć się efektywnego researchu z pomocą AI",
        aiMode: "research",
        aiStartMessage: `**Strukturalny research**

Przeprowadzę z Tobą research jak profesjonalny analityk:

1. Definiujemy cel i pytania badawcze
2. Zbieramy informacje systematycznie
3. Analizujemy i szukamy wzorców
4. Tworzymy syntezę z wnioskami

---

**Jaki temat chcesz zbadać?**

Najlepiej sprawdza się na:
- analizie rynku lub branży
- researchu przed ważną decyzją
- zbieraniu materiału do prezentacji
- analizie trendu lub technologii

Twój temat?`
      },
      {
        id: "d7_t2",
        title: "Analiza: Warsztat analityczny",
        description: "Naucz się rozkładać informacje na czynniki z pomocą AI",
        goal: "Opanować profesjonalną analizę informacji",
        aiMode: "analysis_workshop",
        aiStartMessage: `**Warsztat analityczny**

Nauczę Cię profesjonalnej analizy informacji - umiejętności, która zmienia jakość decyzji.

**Co przeanalizujemy?**

Możesz podać:
- tekst lub artykuł do analizy
- sytuację biznesową do rozkładu
- dane lub statystyki do interpretacji
- problem wymagający dekompozycji

Wklej lub opisz to, co mam przeanalizować.`
      },
      {
        id: "d7_t3",
        title: "Krytyczne myślenie: Nie ufaj AI ślepo",
        description: "Naucz się weryfikować, kwestionować i krytycznie oceniać odpowiedzi AI",
        goal: "Rozwinąć krytyczną ocenę odpowiedzi AI",
        aiMode: "critical_thinking",
        aiStartMessage: `**Weryfikacja krytyczna**

Jedna z najważniejszych umiejętności: **nie ufać AI ślepo**.

Zrobimy eksperyment. Podam stwierdzenie. Twoim zadaniem jest je zakwestionować.

---

**Stwierdzenie:**

*"Najlepsze prompty powinny zawsze zaczynać się od nadania roli AI. Bez tego odpowiedzi są zawsze gorsze."*

---

Co myślisz? Czy to zawsze prawda? Kiedy mogłoby to nie działać? Jakie widzisz wyjątki?

Napisz swoją analizę.`
      }
    ]
  }
};

// ═══════════════════════════════════════════════════════════════════════════
// Fallback dla dni 8+
// ═══════════════════════════════════════════════════════════════════════════

export const getTasksForDay = (dayNumber) => {
  if (dayTasks[dayNumber]) {
    return dayTasks[dayNumber];
  }
  
  return {
    dayTitle: `Dzień ${dayNumber}`,
    dayContext: "Zaawansowane techniki AI",
    tasks: [
      {
        id: `d${dayNumber}_t1`,
        title: "Sesja treningowa z Mentorem",
        description: "Interaktywna sesja dopasowana do Twojego poziomu",
        goal: "Utrwalić i rozwinąć umiejętności promptowania",
        aiMode: "training",
        aiStartMessage: `**Sesja treningowa**

Czas na praktykę! Przeprowadzę sesję dopasowaną do Twojego poziomu.

**Wybierz intensywność:**

1. **Fundamenty** – powtórka kluczowych technik
2. **Łączenie technik** – kilka metod w jednym zadaniu
3. **Wyzwanie pro** – zadanie na poziomie zaawansowanym

Który poziom? (1-3)`
      },
      {
        id: `d${dayNumber}_t2`,
        title: "Rozwiąż realny problem",
        description: "Użyj wszystkich poznanych technik do prawdziwego wyzwania",
        goal: "Praktyczne zastosowanie wiedzy do realnego problemu",
        aiMode: "problem_solving",
        aiStartMessage: `**Problem-solving**

Rozwiążemy razem PRAWDZIWY problem. Użyjemy wszystkich technik, które już znasz.

---

**Opisz wyzwanie** z pracy, projektu lub życia.

Im bardziej konkretne, tym lepiej pomogę. Nie ma złych tematów - liczy się praktyka.`
      },
      {
        id: `d${dayNumber}_t3`,
        title: "Laboratorium: Zaawansowany eksperyment",
        description: "Eksperymentuj z zaawansowanymi technikami pod okiem Mentora",
        goal: "Odkrywać nowe, zaawansowane możliwości AI",
        aiMode: "lab",
        aiStartMessage: `**Laboratorium AI**

Eksperymentujemy z zaawansowaną techniką: **Prompt Chaining z Refinement Loop**.

To metoda, gdzie:
1. Tworzysz pierwszy prompt
2. AI analizuje wynik i sugeruje ulepszenia
3. Iterujesz aż do optymalnego rezultatu

Każda iteracja automatycznie buduje na poprzedniej.

---

**Podaj temat** do eksperymentu - cokolwiek, na czym chcesz przetestować tę technikę.`
      }
    ]
  };
};

export default dayTasks;
